/**
 * Created by swchen on 2017/2/14.
 */

import NumasException from "./NumasException";

export default class ServiceException extends NumasException {

    static SERVER_ERROR = "Internal Server Error";
    static CLIENT_ERROR = "Client Error";

    static CUSTOM_TYPE = "CUSTOM_TYPE"; // 接口自定义错误类型

    constructor(code, message, level, path, type) {
        super(code, message, level);
        this.path = path;
        this.type = type;
    }
}

